<template>
  <div>
    <div v-if="date">
      <div>
        <span>
          <b>
            <span class="no-wrap">{{ readableDate(date) }}</span>
          </b>
        </span>
      </div>
      <div v-if="displayTime">
        <span class="text-muted">{{ readableTime(date) }}</span>
      </div>
    </div>
    <div v-else>-</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { readableDate, readableTime } from '@/services/Helpers'

export default defineComponent({
  name: 'RowDate',
  props: {
    date: {
      type: String,
      required: false,
      default: '',
    },
    displayTime: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup() {
    return {
      readableDate,
      readableTime,
    }
  },
})
</script>
